import React from "react"
import ProtectedLayout from "layouts/Protected"
import { useTranslation } from "react-i18next"

export const ErrorPage = () => {
	const { t } = useTranslation()
	return (
		<ProtectedLayout className="px-7 py-7">
			<div className="flex justify-center py-7">
				<div className="l-form-width">
					<p className="">{t("error_page.message")}</p>
				</div>
			</div>
		</ProtectedLayout>
	)
}
